import React, {useEffect, useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {
    GUTTER_MD,
    GUTTER_SM,
    MARGIN_MD,
    MODAL_WIDTH_LG,
    SPAN_HALF,
    SPAN_ONE_THIRD,
    TABLE_COL_MIN_WIDTH_ID
} from "../../../../../../styles/constants";
import {Button, Card, Checkbox, Col, Form, Icon, Input, Modal, Row, Select} from "antd";
import PerfInput from "../../../../../../components/perf-input";
import EnhancedModal from "../../../../../../components/enhanced-modal";
import {CREATE_MODE, DELETE_MODE} from "../utils";
import {connect} from "react-redux";
import {
    areInputExtensionsInvalid,
    isRequiredFieldAbsent,
    isOutputExtensionInvalid,
    isMultiLangNameInvalid,
    isPluginUidInvalid, isPluginValid, isIconColorInvalid,
} from "./validateUtils";
import MultilanguageInput from "../../../../../../components/multilanguage-input";
import _ from "lodash";
import {getColorsList, getIconsList} from "../../../actions";
import Call from "../../../../../../hocs/call";
import ModalSelector from "./ModalSelector";


const rowStyle = {
    marginBottom: MARGIN_MD,
};

const SELECT_EXTENSION_CHOICES = [".json", ".xml"];

const InlineCheckbox = ({label, fieldId, form, justify = "start", disabled = false}) => {
    return (<Row type="flex" justify={justify} align="middle" gutter={GUTTER_MD}>
        <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
            {label}:
        </Col>
        <Col>
            <Form.Item disabled={disabled}>
                {form.getFieldDecorator(fieldId, {valuePropName: 'checked'})(
                    <Checkbox disabled={disabled}/>
                )}
            </Form.Item>
        </Col>
    </Row>)
}

const mapStateToProps = state => ({
    icons: state.scenes.configuration.nodesConfig.icons,
    colors: state.scenes.configuration.nodesConfig.colors
});


const mapDispatchToProps = dispatch => ({
    onGetIconsList: () => dispatch(getIconsList()),
    onGetColorsList: () => dispatch(getColorsList())
})

const mapPropsToFields = ({modalInfo}) => {
    const {plugin} = modalInfo;
    return {
        PluginUid: Form.createFormField({value: plugin ? plugin.PluginUid : null}),
        PluginName: Form.createFormField({value: plugin ? plugin.PluginName : null}),
        MenuName: Form.createFormField({value: plugin ? plugin.MenuName : null}),
        DllName: Form.createFormField({value: plugin ? plugin.DllName : null}),
        InputExtensions: Form.createFormField({value: plugin ? plugin.InputExtensions : null}),
        OutputExtension: Form.createFormField({value: plugin ? plugin.OutputExtension : null}),
        TransformExtension: Form.createFormField({value: plugin ? plugin.TransformExtension : null}),
        ProcessExtension: Form.createFormField({value: plugin ? plugin.ProcessExtension : null}),
        FileMappingEnabled: Form.createFormField({value: plugin ? plugin.FileMappingEnabled : false}),
        ProcessFileEnabled: Form.createFormField({value: plugin ? plugin.ProcessFileEnabled : false}),
        ReportEnabled: Form.createFormField({value: plugin ? plugin.ReportEnabled : false}),
        TransformFileEnabled: Form.createFormField({value: plugin ? plugin.TransformFileEnabled : false}),
        MainMenuEnabled: Form.createFormField({value: plugin ? plugin.MainMenuEnabled : false}),
        Enabled: Form.createFormField({value: plugin ? plugin.Enabled : false}),
        SequenceMappingEnabled: Form.createFormField({value: plugin ? plugin.SequenceMappingEnabled : false}),
        Icon: Form.createFormField({value: plugin ? plugin.Icon : null}),
        IconColor: Form.createFormField({value: plugin ? plugin.IconColor : null}),
        SequenceMappingIcon: Form.createFormField({value: plugin ? plugin.SequenceMappingIcon : null}),
        SequenceMappingIconColor: Form.createFormField({value: plugin ? plugin.SequenceMappingIconColor : null}),
    }
};

const checkAndUpdatePlugin = (plugin, allIDs, modalInfo, t, onModalHide) => {
    if (isPluginValid(plugin, allIDs, modalInfo, t)) {
        modalInfo.action(plugin);
        onModalHide();
    } else {
        Modal.warning({
            title: t('commons.alerts.invalidForm.title'),
            content: t('commons.alerts.invalidForm.content')
        });
    }
}

const CreateModifyPluginModal = ({
                                     isModalVisible,
                                     onModalHide,
                                     modalInfo,
                                     t,
                                     form,
                                     Plugins = [],
                                     onGetIconsList,
                                     icons,
                                     onGetColorsList,
                                     colors
                                 }) => {
    const allIDs = useMemo(() => (Plugins || []).map(item => item.PluginUid).sort((a, b) => a.localeCompare(b)), [Plugins]);

    useEffect(() => {
        if (isModalVisible && !form.getFieldValue("Enabled")) {
            form.setFields({"MainMenuEnabled": false, "FileMappingEnabled": false});
        }
    }, [form.getFieldValue("Enabled"), isModalVisible]);


    useEffect(() => {
        if (isModalVisible && !!form.getFieldValue("Enabled") && !form.getFieldValue("FileMappingEnabled")) {
            form.setFieldsValue({"SequenceMappingEnabled": false});
        }
    }, [form.getFieldValue("Enabled"), form.getFieldValue("FileMappingEnabled"), isModalVisible]);

    useEffect(() => {
        if (isModalVisible && !form.getFieldValue("SequenceMappingEnabled")) {
            form.setFieldsValue({"SequenceMappingIcon": null, "SequenceMappingIconColor": null});
        }
    }, [form.getFieldValue("SequenceMappingEnabled"), isModalVisible]);


    useEffect(() => {
        if (!form.getFieldValue("ProcessFileEnabled")) {
            form.setFieldsValue({"ProcessExtension": null});
        }
    }, [form.getFieldValue("ProcessFileEnabled")]);

    useEffect(() => {
        if (!form.getFieldValue("TransformFileEnabled")) {
            form.setFieldsValue({"TransformExtension": null});
        }
    }, [form.getFieldValue("TransformFileEnabled")]);

    const pluginIsEnabledForMainMenu = useMemo(() => !!form.getFieldValue("Enabled") && !!form.getFieldValue("MainMenuEnabled"), [form.getFieldValue("Enabled"), form.getFieldValue("MainMenuEnabled")]);
    const pluginIsEnabledForFileMapping = useMemo(() => !!form.getFieldValue("Enabled") && !!form.getFieldValue("FileMappingEnabled"), [form.getFieldValue("Enabled"), form.getFieldValue("FileMappingEnabled")]);




    const iconsMap = useMemo(() => !!icons ? _.map(icons, (e) => ({
        name: e,
        icon: <div
            style={{width: 20, height: 20, background: 'white', border: '1px solid #bababa', textAlign: 'center'}}><Icon
            type={e}/></div>
    })) : [], [icons])

    const colorsMap = useMemo(() => !!colors ? _.map(colors, (e) => ({
        name: e,
        color: <div style={{width: 20, height: 20, background: e.replaceAll("_", ""), border: '1px solid #bababa'}} title={e}></div>
    })) : [], [colors])

    return (
        <EnhancedModal
            visible={isModalVisible}
            onCancel={onModalHide}
            bodyStyle={{maxHeight: "75vh"}}
            title={modalInfo ? t(`components.pluginsList.modals.${modalInfo.mode}.title`, {
                pluginName: modalInfo.plugin ? modalInfo.plugin.pluginName : ""
            }) : ""}
            width={MODAL_WIDTH_LG}
            footer={<Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                <Col>
                    <Button
                        onClick={onModalHide}>{t('commons.buttons.close.title')}
                    </Button>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        onClick={() => checkAndUpdatePlugin(form.getFieldsValue(), allIDs, modalInfo, t, onModalHide)}
                    >
                        {t(`commons.buttons.${modalInfo.mode !== DELETE_MODE ? "save" : "ok"}.title`)}
                    </Button>
                </Col>
            </Row>}
        >
            <Call cb={onGetIconsList} disabled={icons}>
                <Call cb={onGetColorsList} disabled={colors}>
                    <Form>
                        <Form.Item
                            label={t('data.plugins.id.label')}
                            className="ant-form-item-required"
                            required
                            validateStatus={isPluginUidInvalid(modalInfo, form.getFieldValue("PluginUid"), allIDs, t, false) ? "warning" : null}
                            help={isPluginUidInvalid(modalInfo, form.getFieldValue("PluginUid"), allIDs, t, false)}

                        >
                            {form.getFieldDecorator('PluginUid')(
                                <PerfInput
                                    disabled={modalInfo.mode !== CREATE_MODE}
                                    onInput={e => e.target.value = e.target.value.toUpperCase()}
                                    Component={Input}
                                    title={form.getFieldValue('PluginUid')}
                                />
                            )}
                        </Form.Item>
                        <InlineCheckbox label={t('data.plugins.enabled.label')} fieldId='Enabled' form={form}/>
                        <Card bodyStyle={{paddingTop: GUTTER_SM, paddingBottom: GUTTER_SM}}>
                            <Row style={!form.getFieldValue("Enabled") ? {opacity: 0.5} : undefined}>
                                <Col span={SPAN_ONE_THIRD}>
                                    <InlineCheckbox label={t('data.plugins.mainMenu.label')} fieldId='MainMenuEnabled'
                                                    disabled={!form.getFieldValue("Enabled")}
                                                    form={form}/>
                                </Col>
                                <Col span={SPAN_ONE_THIRD}>

                                    <InlineCheckbox label={t('data.plugins.mapping.label')} fieldId='FileMappingEnabled'
                                                    form={form} justify="center"
                                                    disabled={!form.getFieldValue("Enabled")}/>

                                </Col>
                                <Col span={SPAN_ONE_THIRD}>
                                    <InlineCheckbox label={t('data.plugins.sequenceMapping.label')}
                                                    fieldId='SequenceMappingEnabled'
                                                    form={form} justify="end"
                                                    disabled={!pluginIsEnabledForFileMapping}/>
                                </Col>
                            </Row>
                        </Card>
                        <Form.Item label={t('data.plugins.options.label')}>
                            <Card bodyStyle={{paddingTop: GUTTER_SM, paddingBottom: GUTTER_SM}}>
                                <Row>
                                    <Col span={SPAN_ONE_THIRD}>
                                        <InlineCheckbox label={t('data.plugins.config.label')}
                                                        fieldId='TransformFileEnabled'
                                                        form={form}/>
                                    </Col>
                                    <Col span={SPAN_ONE_THIRD}>
                                        <InlineCheckbox label={t('data.plugins.process.label')}
                                                        fieldId='ProcessFileEnabled' form={form} justify="center"/>

                                    </Col>
                                    <Col span={SPAN_ONE_THIRD}>
                                        <InlineCheckbox label={t('data.plugins.report.label')} fieldId='ReportEnabled'
                                                        form={form} justify="end"/>
                                    </Col>
                                </Row>
                            </Card>
                        </Form.Item>
                        <Form.Item
                            label={t('data.plugins.menuName.label')}
                            required={pluginIsEnabledForMainMenu}
                            className={pluginIsEnabledForMainMenu ? "ant-form-item-required" : undefined}
                            validateStatus={isMultiLangNameInvalid(t, form.getFieldValue("MenuName"), false) ? "warning" : null}
                            help={isMultiLangNameInvalid(t, form.getFieldValue("MenuName"), false)}

                        >
                            {form.getFieldDecorator('MenuName')(
                                <MultilanguageInput disabled={!pluginIsEnabledForMainMenu}/>
                            )}
                        </Form.Item>

                        <Form.Item
                            label={t('data.plugins.pluginName.label')}
                            required={pluginIsEnabledForFileMapping}
                            className={pluginIsEnabledForFileMapping ? "ant-form-item-required" : undefined}
                            validateStatus={isMultiLangNameInvalid(t, form.getFieldValue("PluginName"), false) ? "warning" : null}
                            help={isMultiLangNameInvalid(t, form.getFieldValue("PluginName"), false)}

                        >
                            {form.getFieldDecorator('PluginName')(
                                <MultilanguageInput disabled={!pluginIsEnabledForFileMapping}/>
                            )}
                        </Form.Item>

                        <Form.Item
                            required
                            className="ant-form-item-required"
                            label={t('data.plugins.fileName.label')}
                            validateStatus={isRequiredFieldAbsent(t, form.getFieldValue("DllName"), false) ? "warning" : null}
                            help={isRequiredFieldAbsent(t, form.getFieldValue("DllName"), false)}
                        >
                            {form.getFieldDecorator('DllName')(
                                <PerfInput
                                    placeholder="plugin-folder/plugin-name.dll"
                                    Component={Input}
                                    title={form.getFieldValue('DllName')}
                                />
                            )}
                        </Form.Item>
                        <Row gutter={GUTTER_MD}>
                            <Col span={SPAN_HALF}>
                                {form.getFieldDecorator('Icon')(
                                    <Form.Item label={t('data.plugins.iconName.label')}>
                                        <ModalSelector fieldName="Icon"
                                                       form={form}
                                                       columns={[
                                                           {
                                                               title: t('data.plugins.modals.iconName.table.columns.name'),
                                                               dataIndex: 'name',
                                                               minWidth: TABLE_COL_MIN_WIDTH_ID
                                                           },
                                                           {
                                                               title: t('data.plugins.modals.iconName.table.columns.icon'),
                                                               dataIndex: 'icon',
                                                               minWidth: TABLE_COL_MIN_WIDTH_ID,
                                                           },
                                                       ]} data={iconsMap}
                                                       modalTitle='data.plugins.modals.iconName.title'/>
                                    </Form.Item>
                                )}
                            </Col>
                            <Col span={SPAN_HALF}>
                                {form.getFieldDecorator('IconColor')(
                                    <Form.Item
                                        label={t('data.plugins.iconColor.label')}
                                        validateStatus={!!isIconColorInvalid(t, form.getFieldValue("IconColor"), form.getFieldValue("SequenceMappingIconColor")) ? "warning" : null}
                                        help={isIconColorInvalid(t, form.getFieldValue("IconColor"), form.getFieldValue("SequenceMappingIconColor"))}
                                    >
                                        <ModalSelector fieldName="IconColor"
                                                       form={form}
                                                       columns={[
                                                           {
                                                               title: t('data.plugins.modals.iconColor.table.columns.name'),
                                                               dataIndex: 'name',
                                                               minWidth: TABLE_COL_MIN_WIDTH_ID
                                                           },
                                                           {
                                                               title: t('data.plugins.modals.iconColor.table.columns.color'),
                                                               dataIndex: 'color',
                                                               minWidth: TABLE_COL_MIN_WIDTH_ID,
                                                           },
                                                       ]} data={colorsMap}
                                                       modalTitle='data.plugins.modals.iconColor.title'/>
                                    </Form.Item>
                                )}
                            </Col>
                        </Row>
                        <Row gutter={GUTTER_MD}>
                            <Col span={SPAN_HALF}>
                                {form.getFieldDecorator('SequenceMappingIcon')(
                                    <Form.Item label={t('data.plugins.sequenceMappingIcon.label')}>
                                        <ModalSelector
                                            fieldName="SequenceMappingIcon"
                                            form={form}
                                            columns={[
                                                {
                                                    title: t('data.plugins.modals.iconName.table.columns.name'),
                                                    dataIndex: 'name',
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                                },
                                                {
                                                    title: t('data.plugins.modals.iconName.table.columns.icon'),
                                                    dataIndex: 'icon',
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID,
                                                },
                                            ]}
                                            data={iconsMap}
                                            modalTitle='data.plugins.modals.sequenceMappingIcon.title'
                                            disabled={!form.getFieldValue("SequenceMappingEnabled")}
                                        />
                                    </Form.Item>
                                )}
                            </Col>
                            <Col span={SPAN_HALF}>
                                {form.getFieldDecorator('SequenceMappingIconColor')(
                                    <Form.Item
                                        label={t('data.plugins.sequenceMappingIconColor.label')}
                                        validateStatus={!!isIconColorInvalid(t, form.getFieldValue("IconColor"), form.getFieldValue("SequenceMappingIconColor")) ? "warning" : null}
                                        help={isIconColorInvalid(t, form.getFieldValue("IconColor"), form.getFieldValue("SequenceMappingIconColor"))}

                                    >
                                        <ModalSelector
                                            fieldName="SequenceMappingIconColor"
                                            form={form}
                                            columns={[
                                                {
                                                    title: t('data.plugins.modals.iconColor.table.columns.name'),
                                                    dataIndex: 'name',
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                                },
                                                {
                                                    title: t('data.plugins.modals.iconColor.table.columns.color'),
                                                    dataIndex: 'color',
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID,
                                                },
                                            ]}
                                            data={colorsMap}
                                            modalTitle='data.plugins.modals.sequenceMappingIconColor.title'
                                            disabled={!form.getFieldValue("SequenceMappingEnabled")}
                                        />
                                    </Form.Item>
                                )}
                            </Col>
                        </Row>
                        <Row gutter={GUTTER_MD} style={rowStyle}>
                            <Col span={SPAN_HALF}>
                                <Form.Item
                                    label={t('data.plugins.inputExtensions.label')}
                                    required
                                    className="ant-form-item-required"
                                    validateStatus={!!areInputExtensionsInvalid(t, form.getFieldValue("InputExtensions"), false) ? "warning" : null}
                                    help={areInputExtensionsInvalid(t, form.getFieldValue("InputExtensions"), false)}

                                >
                                    {form.getFieldDecorator('InputExtensions')(
                                        <PerfInput
                                            placeholder=".xls;.xlsx"
                                            Component={Input}
                                            title={form.getFieldValue('InputExtensions')}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={SPAN_HALF}>
                                <Form.Item
                                    label={t('data.plugins.outputExtension.label')}
                                    required={pluginIsEnabledForMainMenu}
                                    className={pluginIsEnabledForMainMenu ? "ant-form-item-required" : undefined}
                                    validateStatus={!!isOutputExtensionInvalid(t, form.getFieldValue("OutputExtension"), false) ? "warning" : null}
                                    help={isOutputExtensionInvalid(t, form.getFieldValue("OutputExtension"), false)}

                                >
                                    {form.getFieldDecorator('OutputExtension')(
                                        <PerfInput
                                            placeholder=".csv"
                                            Component={Input}
                                            title={form.getFieldValue('OutputExtension')}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={GUTTER_MD} style={rowStyle}>
                            <Col span={SPAN_HALF}>
                                <Form.Item
                                    label={t('data.plugins.configExtension.label')}
                                    required={!!form.getFieldValue("TransformFileEnabled")}
                                    className={!!form.getFieldValue("TransformFileEnabled") ? "ant-form-item-required" : undefined}
                                    validateStatus={isRequiredFieldAbsent(t, form.getFieldValue("TransformExtension"), false) ? "warning" : null}
                                    help={isRequiredFieldAbsent(t, form.getFieldValue("TransformExtension"), false)}
                                >
                                    {form.getFieldDecorator('TransformExtension')(
                                        <Select
                                            showSearch
                                            disabled={!form.getFieldValue('TransformFileEnabled')}
                                            filterOption={(inputValue, {props}) =>
                                                props.title.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                            title={
                                                form.getFieldValue('TransformExtension')
                                            }
                                        >
                                            {SELECT_EXTENSION_CHOICES.map((ext, index) => {
                                                return (
                                                    <Select.Option
                                                        key={index}
                                                        value={ext}
                                                        title={ext}
                                                    >
                                                        {ext}
                                                    </Select.Option>
                                                );
                                            })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={SPAN_HALF}>
                                <Form.Item
                                    label={t('data.plugins.processExtension.label')}
                                    required={!!form.getFieldValue("ProcessFileEnabled")}
                                    className={!!form.getFieldValue("ProcessFileEnabled") ? "ant-form-item-required" : undefined}
                                    validateStatus={isRequiredFieldAbsent(t, form.getFieldValue("ProcessExtension"), false) ? "warning" : null}
                                    help={isRequiredFieldAbsent(t, form.getFieldValue("ProcessExtension"), false)}
                                >
                                    {form.getFieldDecorator('ProcessExtension')(
                                        <Select
                                            showSearch
                                            disabled={!form.getFieldValue('ProcessFileEnabled')}
                                            filterOption={(inputValue, {props}) =>
                                                props.title.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                            title={
                                                form.getFieldValue('ProcessExtension')
                                            }
                                        >
                                            {SELECT_EXTENSION_CHOICES.map((ext, index) => {
                                                return (
                                                    <Select.Option
                                                        key={index}
                                                        value={ext}
                                                        title={ext}
                                                    >
                                                        {ext}
                                                    </Select.Option>
                                                );
                                            })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Call>
            </Call>
        </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({mapPropsToFields})
)(CreateModifyPluginModal);